import React from 'react';
import BasicModal from "../../components/common/BasicModal";
import ResourceForm from "components/forms/ResourceForm";
import config from './leadGenFieldPickerFormConfig';
import ErrorDisplay from "components/common/ErrorDisplay";
import LeadGenFieldPickerCheckbox from "./LeadGenFieldPickerCheckbox";

const components = {
    'checkbox': LeadGenFieldPickerCheckbox
};

const LeadGenFieldPickerModal = (props) => (
    <BasicModal header="Select Form Fields"
                specialType="primary-modal db-lead-gen-field-picker fadeInUp animResponse"
                dimmer={'inverted'}
                modalSize="small"
                actions={[
                    {
                        label: "Cancel",
                        action: props.handleClose,
                        isDisabled: false,
                        displayType: "menu-item"
                    },
                    {
                        label: "Create Fields",
                        action: props.submit,
                        isDisabled: props.hasErrors === true,
                        displayType: "button",
                        primaryCheck: true
                    }
                ]}
                open={props.modalOpen}
                onClose={props.handleClose}>
        <ResourceForm resource={props.formData}
                      config={config}
                      components={components}
                      errors={props.errors}
                      onValueChanged={props.onValueChanged}
                      onValidationError={props.onValidationError}/>

        <ErrorDisplay error={props.creationError}/>
    </BasicModal>
);

export default LeadGenFieldPickerModal;


// WEBPACK FOOTER //
// ./public/pages/LeadGenFieldPicker/LeadGenFieldPickerModal.jsx